import useAxios from "axios-hooks";
import { Link, useNavigate } from "react-router-dom";
import ThemeToggler from "../input/ThemeToggler";
import { useContext, useState } from "react";
import { UserContext } from "../../App";

export default function NavbarTop(props: { titleComponent?: React.ReactNode }) {
  const navigate = useNavigate();
  const user = useContext(UserContext);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const [{}, logout] = useAxios(
    {
      url: "/auth/logout",
      method: "POST",
    },
    { manual: true }
  );

  const handleLogout = async (e: React.MouseEvent) => {
    e.preventDefault();
    setIsLoggingOut(true);
    try {
      await logout();
      navigate("/auth/login");
    } catch (error) {
      console.error("Logout failed:", error);
      setIsLoggingOut(false);
    }
  };

  // Extract initials or fallback avatar text
  const avatarText =
    user?.["cognito:username"]?.slice(0, 2).toUpperCase() || "??";

  return (
    <nav className="navbar z-20 bg-base-200 px-5 shadow-md ">
      <div className="flex-1 text-xl font-semibold text-primary">
        {props.titleComponent}
      </div>

      <ThemeToggler />

      <div className="dropdown dropdown-end ml-4">
        <button
          tabIndex={0}
          aria-label="User menu"
          className="btn btn-ghost btn-circle  focus:ring-2 focus:ring-primary focus:outline-none "
        >
          <div className="w-10 h-10 rounded-full border border-base-300 bg-base-100 flex items-center justify-center text-lg font-bold ">
            <div className="">{avatarText}</div>
          </div>
        </button>

        <ul
          tabIndex={0}
          className="menu menu-sm dropdown-content mt-3 p-2 shadow-lg bg-base-200 border border-base-300 rounded-box w-52 z-20"
        >
          <li>
            <Link to="/account/settings" className="hover:text-primary">
              Settings
            </Link>
          </li>

          <li>
            <button
              onClick={handleLogout}
              disabled={isLoggingOut}
              className="justify-between text-error hover:text-error-focus flex items-center"
            >
              Logout
              {isLoggingOut && (
                <span className="loading loading-spinner loading-xs ml-2" />
              )}
            </button>
          </li>
        </ul>
      </div>
    </nav>
  );
}
